import darkPalette from '../palette/dark.json';
import lightPalette from '../palette/light.json';

export interface PaletteConfig {
    name: string;
    colors: {
        theme: {
            brandColor1: string;
            brandColor2: string;
            brandColor3: string;
            brandColor4: string;
            button: string;
            appBg: string;
            appBar: string;
            navButtonNeutral: string;
            navButtonActive: string;
            contentBgOpaque: string;
            contentBg: string;
            campaignCard: string;
            inputBg: string;
            error: string;
            warning: string;
            success: string;
            info: string;
        };
        common: {
            white: string;
            black: string;
            red: string;
            orange: string;
            yellow: string;
            green: string;
            greenDark: string;
            blue: string;
            purple: string;
            pink: string;
        };
        text: {
            headings: string;
            paragraphs: string;
            neutral: string;
            muted: string;
            url: string;
        };
        gradient: {
            gradient1: string;
        };
    };
    sizes: {
        borderRadius: {
            card: string;
            item: string;
            input: string;
            navBar: string;
        };
        padding: {
            card: string;
            item: string;
        };
        margin: {
            navBar: string;
        };
    };
    shadows: {
        card: string;
        button: string;
    };
}

export const palettes = {
    dark: darkPalette as PaletteConfig,
    light: lightPalette as PaletteConfig
};

export const getThemePalette = (mode: 'dark' | 'light'): PaletteConfig => {
    return palettes[mode];
};

export default palettes;